import { render, staticRenderFns } from "./Aanvragen.vue?vue&type=template&id=e0ff65fa&scoped=true&"
import script from "./Aanvragen.vue?vue&type=script&lang=js&"
export * from "./Aanvragen.vue?vue&type=script&lang=js&"
import style0 from "./Aanvragen.vue?vue&type=style&index=0&id=e0ff65fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ff65fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/vhosts/beheer.p4.shifft.com/httpdocs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VItem } from 'vuetify/lib'
import { VItemGroup } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VScrollYTransition } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VDataTable,VFlex,VHover,VIcon,VItem,VItemGroup,VLayout,VRow,VScrollYTransition,VSpacer})
